module.exports = __webpack_public_path__ + "img/hoslogo8.408b2440.png";